import React from 'react';

function NotFoundPage() {
  return (
    <div>
      <h1>404</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
    </div>
  );
}

export default NotFoundPage;
